export const CacheStrategy = {
  None: 'None',
  CacheFirst: 'CacheFirst',
  NetworkFirst: 'NetworkFirst',
  CacheOnly: 'CacheOnly'
};
